import {
	AfterViewInit,
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	inject,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
	ChangeDetectionStrategy,
} from '@angular/core';
import { loanInput } from '@lmc-models/loanInput';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import jsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import { DatePipe, NgIf, NgFor, CurrencyPipe } from '@angular/common';
import { Router } from '@angular/router';
import { SharedServiceService } from '@lmc-app/shared-service.service';
import { FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { LegalFeeExceptionModalComponent } from './legal-fee-exception-modal/legal-fee-exception-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FundedDetailsModalComponent } from './funded-details-modal/funded-details-modal.component';
import { PartialWaiveoffModalComponent } from './partial-waiveoff-modal/partial-waiveoff-modal.component';
import { User } from '@lmc-app/shared/interface/user.interface';
import { LoanCalculatorScriptComponent } from './loan-calculator-script/loan-calculator-script.component';
import {
	BehaviorSubject,
	distinctUntilChanged,
	filter,
	fromEvent,
	map,
	Subject,
	take,
	takeUntil,
} from 'rxjs';
import { AgreementLoanCalculatorService } from '../docusign/agreements/services/agreements-calculator.service';
import { ListenerService } from '@lmc-app/core/services/listener.service';
import { MatIcon } from '@angular/material/icon';
import {
	MatFormField,
	MatLabel,
	MatInput,
	MatSuffix,
	MatError,
} from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import {
	MatDatepickerInput,
	MatDatepickerToggle,
	MatDatepicker,
} from '@angular/material/datepicker';

interface Manager_Overwrite {
	value: boolean;
	viewValue: string;
}
interface IPeriodDropDown {
	value: number;
	viewValue: string;
}

interface Loan_Type {
	value: string;
	viewValue: string;
}
interface Term_Type {
	value: string;
	viewValue: string;
}
interface Province {
	value: string;
	viewValue: string;
}
interface Credit_Upgrader {
	value: string;
	viewValue: string;
}
interface Insurance {
	value: string;
	viewValue: string;
}
interface Food {
	value: string;
	viewValue: string;
}
@Component({
	selector: 'app-loancalculator',
	templateUrl: './loancalculator.component.html',
	styleUrls: ['./loancalculator.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	encapsulation: ViewEncapsulation.None,
	imports: [
		MatIcon,
		NgIf,
		MatFormField,
		MatLabel,
		MatSelect,
		ReactiveFormsModule,
		FormsModule,
		NgFor,
		MatOption,
		MatInput,
		MatButton,
		MatIconButton,
		MatSuffix,
		MatProgressSpinner,
		MatError,
		MatDatepickerInput,
		MatDatepickerToggle,
		MatDatepicker,
		CurrencyPipe,
	],
})
export class LoancalculatorComponent
	implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
	@Input() application: any;
	@Input() currentUser: User | null = null;
	@Output() applicationChange = new EventEmitter();
	@HostListener('change', ['$event.target'])
	@ViewChild('content')
	content: ElementRef;
	@ViewChild('fileImportInput') fileImportInput: any;

	private loadingLoanScript = new BehaviorSubject<Boolean>(true);
	public loading$ = this.loadingLoanScript.asObservable();
	loan_type: Loan_Type[] = [];
	term_type: Term_Type[] = [
		{ value: 'Monthly', viewValue: 'Monthly' },
		{ value: 'Weekly', viewValue: 'Weekly' },
		{ value: 'Bi-Weekly', viewValue: 'Bi-Weekly' },
		{ value: '15th and EOM', viewValue: '15th and EOM' },
		{ value: '1st and 15th', viewValue: '1st and 15th' },
	];
	manager_overwrite: Manager_Overwrite[] = [
		{ value: true, viewValue: 'Yes' },
		{ value: false, viewValue: 'No' },
	];

	loan_period: IPeriodDropDown[] = [
		{ value: 1, viewValue: '1' },
		{ value: 2, viewValue: '2' },
		{ value: 3, viewValue: '3' },
		{ value: 4, viewValue: '4' },
		{ value: 5, viewValue: '5' },
	];

	loan_period_Manager: IPeriodDropDown[] = [
		{ value: 1, viewValue: '1' },
		{ value: 2, viewValue: '2' },
		{ value: 3, viewValue: '3' },
		{ value: 4, viewValue: '4' },
		{ value: 5, viewValue: '5' },
		{ value: 6, viewValue: '6' },
		{ value: 7, viewValue: '7' },
		{ value: 8, viewValue: '8' },
		{ value: 9, viewValue: '9' },
		{ value: 10, viewValue: '10' },
		{ value: 11, viewValue: '11' },
		{ value: 12, viewValue: '12' },
		{ value: 13, viewValue: '13' },
		{ value: 14, viewValue: '14' },
		{ value: 15, viewValue: '15' },
	];

	province: Province[] = [
		{ value: 'ON', viewValue: 'Ontario' },
		{ value: 'MB', viewValue: 'Manitoba' },
		{ value: 'NL', viewValue: 'NewFoundLand' },
		{ value: 'SK', viewValue: 'Saskatchewan' },
		{ value: 'NA', viewValue: 'Other' },
	];
	credit_upgrader: Credit_Upgrader[] = [{ value: 'No', viewValue: 'No' }];
	insurance_protection: Insurance[] = [
		{ value: 'Yes', viewValue: 'Yes' },
		{ value: 'No', viewValue: 'No' },
	];
	display_data = {
		Payment: '',
		Scheduled: '',
		LPP: '',
		Insurance: '',
		Tax: '',
		Total_obligation_entire_term: '',
		Total_cost_of_borrowing: '',
		Funded_date: '',
		Start_date: '',
		Maturity_date: '',
		First_payment_amount: '',
		Last_payment_amount: '',
		Setup_fee: '',
		CU_fee: '',
		Accumulative_interest: '',
		LPP_total_interest: '',
		Term: '',
		isEnhanced: 'Standard',
	};

	loanConfig = {
		amount: {
			min: 5000,
			max: 25000,
		},
	};

	zohoexists: boolean;
	ProperSchedule = [];
	read_only_flag = false;
	loanInput = new loanInput();
	Payments;
	payment_Flag = false;
	scheduleArray: any;
	pdf: any;
	doc = new jsPDF('portrait', 'px', 'a4');

	court: any;
	clients: any;
	client_info = [];
	csvRecords: any[] = [];
	header = false;
	start_date_temp;
	funded_date_temp;
	start_date_calc;
	funded_date_calc;
	non_admin_user = true;
	spinner = false;
	debtSettlementFees: any;

	disableLoanAmount: boolean = true;
	isOldCalculator: boolean = false;

	dsRate = 0;
	dsFeeRate = 0;
	dsAmount = 0;
	dsLoanAmount = 0;
	dsFee = 0;
	newLoanAmount = 0;

	additionalDebts: any;

	totalAccountBalance: any;
	grandTotalNewAmount: any;

	additionalDebt_settlment = []; // Store new calculation

	isInterfaceLoad: boolean = true;

	hasCreditorPortfolio: any;
	hasAccountBalance: any;
	hasCustomSettlement: any;

	loanAmountLoader: boolean = true;
	performDurationUpdate: boolean = true; // Not to calculate duration if loan calculator entry found
	dbLoanAmount: any;

	selectedProvince: string;
	verifiedResult: any;
	reloadLoanCalculator = true;
	// partialRate = new FormControl<number | null>(null, Validators.required);
	// selectedWaiveOffMode = new FormControl<string | null>(null);
	public data = inject(MAT_DIALOG_DATA, { optional: true }); // Agreement Data
	private _agreementDataService = inject(AgreementLoanCalculatorService); // Emit completed i.e true to agreement to generate updates
	private _listenerService = inject(ListenerService); // Listener service
	private readonly _elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
	private readonly _onDestroy = new Subject<void>();
	isScrolled = false;
	constructor(
		public datepipe: DatePipe,
		private apiService: LegacyApiService,
		private sharedService: SharedServiceService,
		private fb: FormBuilder,
		private dialog: MatDialog,
		private router: Router
	) {}

	async ngOnInit() {
		this.spinner = true;
		this.loanInput.Is_Old_Calculator = false;
		this.debtSettlementFees = await this.getnewLoanAmount();
		this.disableLoanAmount = this.debtSettlementFees['disable_loan_amount'];

		// Loan Agreement
		if (!!this.data) {
			console.log(this.data, 'FROM AGREEMENT---------------------------');
			this.application = this.data.originalData;
			this.currentUser = this.data.userInfo;
			this.initializeComponentData();
		}
	}

	Zoho_Connectivity_Issues(application: any) {
		this.loanInput.application_id = application.id;
		this.loanInput.Application_Name = application?.Deal_Name;
		this.loanInput.Province_Name = application?.Province1;
		this.loanInput.Province = application?.Province;
		this.loanInput.id = application?.Application_Number;
		this.loanInput.Loan_Type = 'Standard';
		this.loanInput.CU = 'No';
		this.loanInput.Interest_Rate =
			this.application?.Province === 'BC' ? 31 : 34.99;
	}

	async getLoggedInUser(user_id) {
		return new Promise((resolve, reject) => {
			if (user_id) {
				this.apiService.getZohoLoggedInUser(user_id).subscribe((res) => {
					if (!res) {
						console.log('Error Getting Logged in User Details');
						resolve('');
					} else {
						let user = res['users'][0]['full_name'];
						console.log('Here is the user');
						console.log(res);
						const zohoUserID = res['users'][0]['id'];

						// Platform button permissions
						this.apiService.getBtnPermission().subscribe((res) => {
							let managerAccess = res?.[0]?.loan_calc_manager;
							if (managerAccess?.includes(zohoUserID)) {
								console.log(zohoUserID, '_________Access granted');
								this.non_admin_user = false;
							}
						});
						resolve(user);
					}
				});
			}
		});
	}

	private readonly _snackBar = inject(MatSnackBar);

	// // getApplication(applicationId: string) {
	// // 	this.apiService.getApplication(applicationId).subscribe({
	// // 		next: (res) => {
	// // 			this.application = res;
	// // 			this.loanInput.id = this.application?.App_Number;
	// // 			this.loanInput.Folder_ID =
	// // 				this.application?.gdriveextension__Drive_Folder_ID;
	// // 			this.loanInput.dob = this.application?.Date_of_Birth;
	// // 			this.loanInput.Loan_Type = 'Standard';
	// // 			this.loanInput.Interest_Rate = this.application?.Province === 'BC' ? 31 : 34.99 ;
	// // 			this.loanInput.Insurance = 'No';
	// // 			this.populateNewCalculation(this.application);
	// // 			this.loanInput.Loan_Amount = this.totalAccountBalance;
	// // 			this.onDurationUpdate(this.totalAccountBalance, true);
	// // 		},
	// // 		error: (error) => {
	// // 			console.error(error);
	// // 			this._snackBar.open(
	// // 				error,
	// // 				SnackbarConstants.ACTION_DISMISS,
	// // 				SnackbarConstants.DURATION_DISMISS_SHORT
	// // 			);
	// // 		},
	// // 	});
	// // }

	async getZohoApplication(applicationId) {
		return new Promise((resolve, reject) => {
			this.apiService
				.getZohoApplication(applicationId)
				.subscribe(async (res) => {
					if (!res) {
						alert('UNABLE TO CONNECT TO ZOHO - PLEASE TRY AGAIN IN 1 MINUTE');
						resolve(false);
					} else {
						this.application = res['data'][0];
						this.loanInput.id = this.application?.App_Number;
						this.loanInput.Folder_ID =
							this.application?.gdriveextension__Drive_Folder_ID;
						this.loanInput.dob = this.application?.Date_of_Birth;
						this.loanInput.Loan_Type = 'Standard';
						this.loanInput.Interest_Rate =
							this.application?.Province === 'BC' ? 31 : 34.99;
						this.loanInput.Insurance = 'No';
						await this.populateNewCalculation(this.application);
						this.loanInput.Loan_Amount = this.totalAccountBalance;
						this.onDurationUpdate(this.totalAccountBalance, true);
						console.log(this.application, '______________');
						resolve(true);
					}
				});
		});
	}
	populateCalc() {
		return new Promise(async (resolve, reject) => {
			this.loanInput.loan_calc_created_by = await this.getLoggedInUser(
				this.currentUser?.zoho_owner_id
			);
			this.loanInput.id = this.application.Application_Number;
			this.loanInput.application_id = this.application?.id;
			this.loanInput.Application_Name = this.application?.Deal_Name;
			this.loanInput.Province = this.application?.Province;
			this.loanInput.Province_Name = this.application?.Province1;
			this.loanInput.Loan_Type = 'Standard';
			this.loanInput.CU = 'No';
			console.log(await this.getCalculatorException());
			await this.getLoanConfig();
			if (
				this.loanInput.Province != 'ON' &&
				this.loanInput.Province != 'MB' &&
				this.loanInput.Province != 'NL' &&
				this.loanInput.Province != 'SK'
			)
				this.loanInput.Province = 'NA';
			if (await this.checkCalculatorInstance()) {
				console.log('Calculator already exists in the database');
				const validateExistingLoanAmount = await this.validateLoanAmountMatch(
					this.application,
					this.application?.Account_Bal
				);
				const approvedAmountMatched = await this.checkApprovedAmountZOHO();
				const countZOHOCustomSettlment = await this.countCustomSettlement(
					this.application
				);
				console.log(
					validateExistingLoanAmount,
					approvedAmountMatched,
					'loan calc amount vs zoho amount'
				);
				if (
					this.loanInput.custom_settlement_counts !== countZOHOCustomSettlment
				) {
					this.spinner = false;
					this.loanAmountLoader = false;
					this.resetForm();
				} else if (validateExistingLoanAmount !== approvedAmountMatched) {
					this.spinner = false;
					this.loanAmountLoader = false;
					this.resetForm();
				} else {
					this.performDurationUpdate = false;
					this.calculate(true);
				}
			} else {
				if (await this.getZohoApplication(this.application.id)) {
					console.log(
						'Using application data from binding for new Calculator Creation'
					);
					const appData = this.application;
					this.loanInput.id = appData?.Application_Number;
					this.loanInput.Folder_ID = appData?.gdriveextension__Drive_Folder_ID;
					this.loanInput.dob = appData?.Date_of_Birth;
					this.loanInput.Loan_Type = 'Standard';
					this.loanInput.Interest_Rate =
						this.application?.Province === 'BC' ? 31 : 34.99;
					this.loanInput.Insurance = 'No';
					await this.populateNewCalculation(appData);
					this.loanInput.Loan_Amount = this.totalAccountBalance;

					this.onDurationUpdate(this.totalAccountBalance, true);
					console.log(appData, '______________');
					this.spinner = false;
				} else {
					this.Zoho_Connectivity_Issues(this.application);
					this.performDurationUpdate = true;
					this.calculate(false);
				}
			}
			resolve(true);
		});
	}

	getLoanConfig() {
		this.apiService.getLoanConfig().subscribe((res) => {
			if (!res?.['status']) {
				console.log('Loan config retrieval failed');
			} else {
				try {
					const clientConfig = JSON.parse(res?.['data']?.[0]?.config);
					if (clientConfig) {
						this.loanConfig = clientConfig?.loanConfig;
					}
				} catch (e) {
					console.log('Error setting up load config', e);
				}
			}
		});
	}

	async getCalculatorException() {
		return new Promise((resolve, reject) => {
			this.apiService
				.getExceptionCalculator(this.loanInput.application_id)
				.subscribe((res) => {
					if (!res['status']) {
						this.loanInput.exception = false;
						resolve('Error getting exception status from table');
					} else {
						if (res['data'].length == 0) {
							this.loanInput.exception = false;
							resolve('exception does not exist');
						} else {
							if (res['data'][0]['ex'] == 1) this.loanInput.exception = true;
							else this.loanInput.exception = false;
							resolve('exception status set');
						}
					}
				});
		});
	}

	async checkCalculatorInstance() {
		return new Promise((resolve, reject) => {
			this.apiService
				.getCalculatorInstance(this.loanInput.application_id)
				.subscribe((res) => {
					let calc_info = res;
					this.zohoexists = false;
					this.isOldCalculator = res
						? calc_info[0]['is_old_calculator']
						: false;
					if (res) {
						this.zohoexists = true;
						this.loanInput.Loan_Type = calc_info[0]['loan_type'];
						this.loanInput.Interest_Rate = calc_info[0]['interest_rate'];
						this.loanInput.CU = calc_info[0]['credit_upgrader'];
						this.loanInput.Insurance = calc_info[0]['insurance_protection'];
						this.loanInput.custom_settlement_counts =
							calc_info[0]['custom_settlement_counts'];
						this.loanInput.Loan_Amount = calc_info[0]['original_loan_amount'];
						this.loanInput.Creditor_Portfolio =
							calc_info[0]['creditor_portfolio'];
						this.dbLoanAmount = calc_info[0]['loan_amount'];
						this.loanInput.Duration = calc_info[0]['period'];
						this.loanInput.Term_Type = calc_info[0]['term_type'];
						console.log('Here it is from the database:');
						console.log(calc_info[0]['start_date']);
						console.log(calc_info[0]['funded_date']);
						calc_info[0]['start_date'] = calc_info[0]['start_date'].substring(
							0,
							10
						);
						calc_info[0]['funded_date'] = calc_info[0]['funded_date'].substring(
							0,
							10
						);
						console.log('____________________________');
						this.loanInput.Start_Date = this.datepipe
							.transform(calc_info[0]['start_date'], 'yyyy-MM-dd')
							.concat('T05:00:00.000Z');
						this.loanInput.Funded_Date = this.datepipe
							.transform(calc_info[0]['funded_date'], 'yyyy-MM-dd')
							.concat('T05:00:00.000Z');
						console.log(this.loanInput.Start_Date);
						console.log(this.loanInput.Funded_Date);

						this.loanInput.created_by = calc_info[0]['created_by'];
						this.loanInput.selectedWaiveOffMode =
							calc_info[0]['waive_off_mode'];
						this.loanInput.waiveOffRate = calc_info[0]['waive_off_rate'];
						resolve(true);
					} else {
						resolve(false);
					}
				});
		});
	}
	LoanTypeChange(value: string) {
		switch (value) {
			case 'Standard': {
				this.loanInput.Interest_Rate =
					this.application?.Province === 'BC' ? 31 : 34.99;
				break;
			}
			case 'Old Standard': {
				this.loanInput.Interest_Rate = 49.99;
				break;
			}
			case 'Click and Loan': {
				this.loanInput.Interest_Rate = 25.99;
				this.loanInput.Setup_Fee_APR = 0.24;
				break;
			}
			default: {
				this.loanInput.Interest_Rate = 0;
			}
		}
	}
	formatDate(date) {
		console.log('THE DATES');
		console.log(date);
		var d = new Date(date),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		return [year, month, day].join('-');
	}

	myFilter = (d: Date | null): boolean => {
		const date = d || new Date();
		//Prevent Today from being selected.
		return !this.sameDay(date, new Date());
	};
	formatMaturityDate(date) {
		var d = new Date(date);
		d.setDate(d.getDate() + 1); //adding one day to maturity date
		let month = '' + (d.getMonth() + 1);
		let day = '' + d.getDate();
		let year = d.getFullYear();

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		return [year, month, day].join('-');
	}

	updateException(event) {
		let ex_status = 0;
		console.log('Checkbox has been checked');
		console.log(event.value);
		if (event.value) ex_status = 1;
		this.apiService
			.updateExceptionCalculator(this.loanInput.application_id, ex_status)
			.subscribe((res) => {
				console.log(res);
			});
	}

	onDurationUpdate(duration, onFirstLoad?: boolean) {
		this.loanInput.Loan_Amount = duration;
		if (this.loanInput.exception && !onFirstLoad) {
			return;
		}

		if (
			duration < this.loanConfig?.amount?.min ||
			duration > this.loanConfig?.amount?.max
		) {
			this.loanInput.Duration = null;
			return;
		}

		switch (true) {
			case duration >= 0 && duration <= 2499:
				return (this.loanInput.Duration = 1);
			case duration > 2499 && duration <= 4999:
				return (this.loanInput.Duration = 2);
			case duration > 4999 && duration <= 9999:
				return (this.loanInput.Duration = 3);
			case duration > 9999 && duration <= 12499:
				return (this.loanInput.Duration = 4);
			case duration > 12499 && duration <= this.loanConfig?.amount?.max: // 25000
				return (this.loanInput.Duration = 5);
			default:
				return (this.loanInput.Duration = null);
		}
	}

	sameDay(d1, d2) {
		return (
			d1.getFullYear() === d2.getFullYear() &&
			d1.getMonth() === d2.getMonth() &&
			d1.getDate() === d2.getDate()
		);
	}
	async validationAfterCalculation(existing_flag) {
		return new Promise(async (resolve, reject) => {
			if (!existing_flag) {
				let date1;
				let date2;
				let diff_days;
				let diff_time;
				try {
					date1 = new Date(this.loanInput.Start_Date.toString());
					date2 = new Date(this.loanInput.Funded_Date.toString());
				} catch (error) {
					alert('These dates are invalid');
					this.isInterfaceLoad = true;
					resolve(false);
				}
				diff_time = date1.getTime() - date2.getTime();
				diff_days = diff_time / (1000 * 60 * 60 * 24);
				console.log(diff_days);
				diff_days = parseInt(diff_days.toFixed(0));
				console.log(diff_days);
				if (!this.loanInput.exception) {
					//Check whether Balloon Payment Exists
					if (
						parseFloat(this.display_data.Payment) <
						parseFloat(this.display_data.Last_payment_amount)
					) {
						let allowed_amount =
							(25 / 100) * parseFloat(this.display_data.Payment);
						if (
							parseFloat(this.display_data.Last_payment_amount) -
								allowed_amount >=
							parseFloat(this.display_data.Payment)
						) {
							alert(
								'Balloon Payment Detected, Please Re-Adjust the Interest Adjustment Period'
							);
							console.log(
								'Scheduled Payment : ' + parseFloat(this.display_data.Payment)
							);
							console.log(
								'Last Payment : ' +
									parseFloat(this.display_data.Last_payment_amount)
							);
							this.isInterfaceLoad = true;
							resolve(false);
							return;
						}
					}
					//Check Interest Adjustment Period
					//turn on overwrite manager hamza and zohar

					switch (this.loanInput.Term_Type) {
						case 'Weekly': {
							if (diff_days <= 12 || diff_days >= 20) {
								alert(
									'For Weekly frequency, Interest Adjustment Period should be between 12 to 20 days. Manager Overwrite Required'
								);
								this.isInterfaceLoad = true;
								resolve(false);
								break;
							}
							this.isInterfaceLoad = false;
							resolve(true);
							break;
						}
						case 'Monthly': {
							if (diff_days <= 12 || diff_days >= 60) {
								alert(
									'For Monthly frequency, Interest Adjustment Period should be between 12 to 60 days. Manager Overwrite Required'
								);
								resolve(false);
								this.isInterfaceLoad = true;
								break;
							}
							this.isInterfaceLoad = false;
							resolve(true);
							break;
						}
						case 'Bi-Weekly': {
							if (diff_days <= 14 || diff_days >= 40) {
								alert(
									'For Bi-Weekly frequency, Interest Adjustment Period should be between 14 and 40 days. Manager Overwrite Required'
								);
								this.isInterfaceLoad = true;
								resolve(false);
								break;
							}
							this.isInterfaceLoad = false;
							resolve(true);
							break;
						}
						case '15th and EOM': {
							if (diff_days <= 15 || diff_days >= 40) {
								alert(
									'For Semi-Monthly frequency, Interest Adjustment Period should be between 15 and 40 days. Manager Overwrite Required'
								);
								this.isInterfaceLoad = true;
								resolve(false);
								break;
							}
							this.isInterfaceLoad = false;
							resolve(true);
							break;
						}
						case '1st and 15th': {
							if (diff_days <= 15 || diff_days >= 40) {
								alert(
									'For Semi-Monthly frequency, Interest Adjustment Period should be between 15 and 40 days. Manager Overwrite Required'
								);
								this.isInterfaceLoad = true;
								resolve(false);
								break;
							}
							this.isInterfaceLoad = false;
							resolve(true);
							break;
						}
						default: {
							console.log(this.loanInput.Term_Type);
							alert('Not a valid Payment Frequency');
							this.isInterfaceLoad = true;
							resolve(false);
						}
					}
				}
				resolve(true);
				return;
			} else {
				console.log('_____________________________________');
				console.log('THE CALCULATOR EXISTS BUT VALIDATION WILL NOT BE APPLIED');
				this.isInterfaceLoad = false;
				resolve(true);
			}
		});
	}
	async validateInput(existing_flag) {
		return new Promise((resolve, reject) => {
			if (
				typeof this.loanInput.Funded_Date == 'undefined' ||
				typeof this.loanInput.Start_Date == 'undefined' ||
				!this.loanInput.Loan_Amount ||
				!this.loanInput.Duration ||
				!this.loanInput.CU ||
				!this.loanInput.Insurance ||
				!this.loanInput.Term_Type ||
				!this.loanInput.Loan_Type
			) {
				alert('Missing Loan Information');
				this.setLoading(true);
				resolve(false);
				return;
			}
			if (
				typeof this.loanInput.selectedWaiveOffMode !== 'undefined' &&
				this.loanInput.selectedWaiveOffMode !== null &&
				this.loanInput.selectedWaiveOffMode !== 'null'
			) {
				if (typeof this.loanInput.waiveOffRate == 'undefined') {
					alert('Missing Partial Fee');
					this.setLoading(true);
					resolve(false);
					return;
				} else if (
					this.loanInput.waiveOffRate < 1 ||
					this.loanInput.waiveOffRate >= 100
				) {
					alert('Partial Fee should be between 1 and 99');
					this.setLoading(true);
					resolve(false);
					return;
				}
			}
			this.apiService.isLPPAllowed(this.loanInput).subscribe((res) => {
				if (!res) {
					alert('This Applicant does not qualify for LPP');
					this.setLoading(true);
					resolve(false);
					return;
				}
			});
			//}
			resolve(true);
		});
	}

	async calculate(existing_flag) {
		this.spinner = true;
		this.setLoading(this.spinner); // Loan script modal
		this.loanAmountLoader = true;
		this.loanInput.existing_flag = existing_flag;
		console.log('HERE IS THE LOAN INPUT');
		console.log(this.loanInput);
		this.Payments = null;
		this.ProperSchedule = [];
		if (await this.validateInput(existing_flag)) {
			this.read_only_flag = true;
			switch (this.loanInput.Loan_Type) {
				case 'Standard': {
					await this.getOriginalRequestedLoanAmount(this.application.id);
					this.loanInput.Original_Loan_Amount = this.totalAccountBalance;
					this.loanInput.Loan_Amount = this.grandTotalNewAmount;
					const onlyFirstCalulation = this.performDurationUpdate
						? this.onDurationUpdate(this.loanInput.Loan_Amount, true)
						: '';
					// console.log(this.loanInput.Loan_Amount, "CHECK____________________________")
					this.apiService
						.calculate_am(this.loanInput)
						.subscribe(async (res) => {
							console.log('CALC FROM THE BACKEND');
							console.log(res);
							this.createAmSchedule(res);
							const onSaveSend = !this.isInterfaceLoad
								? this.updateLoanAmount(this.grandTotalNewAmount)
								: '';
							this.spinner = false;
							this.setLoading(this.isInterfaceLoad); // loan script modal
						});
					break;
				}
				case 'Old Standard': {
					await this.getOriginalRequestedLoanAmount(this.application.id);
					this.loanInput.Original_Loan_Amount = this.totalAccountBalance;
					this.loanInput.Loan_Amount = this.grandTotalNewAmount;
					const onlyFirstCalulation = this.performDurationUpdate
						? this.onDurationUpdate(this.loanInput.Loan_Amount, true)
						: '';
					this.apiService
						.calculate_am(this.loanInput)
						.subscribe(async (res) => {
							console.log('CALC FROM THE BACKEND');
							console.log(res);
							this.createAmSchedule(res);
							const onSaveSend = !this.isInterfaceLoad
								? this.updateLoanAmount(this.grandTotalNewAmount)
								: '';
							this.spinner = false;
							this.setLoading(this.isInterfaceLoad);
						});
					break;
				}
				case 'Click and Loan': {
					await this.getOriginalRequestedLoanAmount(this.application.id);
					this.loanInput.Original_Loan_Amount = this.totalAccountBalance;
					this.loanInput.Loan_Amount = this.grandTotalNewAmount;
					const onlyFirstCalulation = this.performDurationUpdate
						? this.onDurationUpdate(this.loanInput.Loan_Amount, true)
						: '';
					this.apiService
						.calculate_am_click_loan(this.loanInput)
						.subscribe((res) => {
							this.createAmSchedule(res);
							const onSaveSend = !this.isInterfaceLoad
								? this.updateLoanAmount(this.grandTotalNewAmount)
								: '';
							this.spinner = false;
							this.setLoading(this.isInterfaceLoad);
						});
					break;
				}
				case 'Custom': {
					await this.getOriginalRequestedLoanAmount(this.application.id);
					this.loanInput.Original_Loan_Amount = this.totalAccountBalance;
					this.loanInput.Loan_Amount = this.grandTotalNewAmount;
					const onlyFirstCalulation = this.performDurationUpdate
						? this.onDurationUpdate(this.loanInput.Loan_Amount, true)
						: '';
					this.apiService.calculate_am(this.loanInput).subscribe((res) => {
						this.createAmSchedule(res);
						const onSaveSend = !this.isInterfaceLoad
							? this.updateLoanAmount(this.grandTotalNewAmount)
							: '';
						this.spinner = false;
						this.setLoading(this.isInterfaceLoad);
					});
					break;
				}
				default: {
					await this.getOriginalRequestedLoanAmount(this.application.id);
					this.loanInput.Original_Loan_Amount = this.totalAccountBalance;
					this.loanInput.Loan_Amount = this.grandTotalNewAmount;
					const onlyFirstCalulation = this.performDurationUpdate
						? this.onDurationUpdate(this.loanInput.Loan_Amount, true)
						: '';
					this.apiService.calculate_am(this.loanInput).subscribe((res) => {
						this.createAmSchedule(res);
						const onSaveSend = !this.isInterfaceLoad
							? this.updateLoanAmount(this.grandTotalNewAmount)
							: '';
						this.spinner = false;
						this.setLoading(this.isInterfaceLoad);
					});
				}
			}
		} else {
			this.loanAmountLoader = false;
			this.spinner = false;
			this.setLoading(this.spinner);
			return;
		}
	}

	getOriginalRequestedLoanAmount(applicationId: any) {
		return new Promise((resolve, reject) => {
			this.additionalDebt_settlment = [];
			this.apiService
				.getZohoApplication(applicationId)
				.subscribe(async (res: any) => {
					// console.log(res?.data[0]?.Account_Bal, "Original Requested Amount");
					await this.populateNewCalculation(res?.data[0]);
					this.loanInput.Loan_Amount = this.totalAccountBalance;
					// this.originalRequestedAmount = this.totalAccountBalance;
					resolve(res?.data[0]);
				});
		});
	}

	async resetForm() {
		await this.checkLoanCalculatorEntry();
		this.loanAmountLoader = true;
		this.additionalDebt_settlment = [];
		this.ProperSchedule = [];
		this.Payments = null;
		this.read_only_flag = false;
		this.loanInput.Loan_Type = 'Standard';
		this.loanInput.Interest_Rate =
			this.application?.Province === 'BC' ? 31 : 34.99;
		// this.loanInput.Interest_Rate = 34.99;
		// this.loanInput.Interest_Rate = 49.99;
		this.zohoexists = false;
		await this.getOriginalRequestedLoanAmount(this.application.id);
		this.loanInput.Loan_Amount = this.totalAccountBalance;
		this.loanInput.Original_Loan_Amount = this.totalAccountBalance;
		// this.onDurationUpdate(this.loanInput.Loan_Amount, true);
		this.setLoading(true);
	}
	async createAmSchedule(res) {
		this.Payments = res;
		for (var i = 0; i < this.Payments.Term_of_Loan; i++) {
			this.ProperSchedule.push(this.Payments.schedule[i]);
			this.Payments.schedule[i].set_LPP_Ending_Balance = (
				parseFloat(this.Payments.schedule[i].set_Beg_Balance) -
				parseFloat(this.Payments.LPP) -
				parseFloat(this.Payments.schedule[i].set_Interest) -
				parseFloat(this.Payments.schedule[i].set_Principal)
			).toFixed(2);
		}
		if (this.Payments['isEnhanced']) {
			this.display_data.isEnhanced = 'Enhanced';
			this.Payments['isEnhanced'] = 'Enhanced';
		} else {
			this.display_data.isEnhanced = 'Standard';
			this.Payments['isEnhanced'] = 'Standard';
		}
		this.Payments.schedule[
			this.Payments.Term_of_Loan - 1
		].set_LPP_Ending_Balance = '0.00';
		this.display_data.Payment = (
			this.Payments.Amortization_Interest +
			this.Payments.LPP +
			this.Payments.CU_Fee
		).toFixed(2);
		this.adjustLastPaymentDateandAmount();
		this.display_data.Scheduled =
			this.Payments.Amortization_Interest.toFixed(2);
		this.display_data.LPP = this.Payments.LPP.toFixed(2);
		let LPP = parseFloat(this.Payments.LPP.toFixed(2));
		this.display_data.Insurance = (
			LPP - parseFloat(this.Payments.Tax_Amount_Per_Payment)
		).toFixed(2);
		this.display_data.Tax = this.Payments.Tax_Amount_Per_Payment.toFixed(2);
		this.Payments.Funded_Date = this.formatDate(this.Payments.Funded_Date);
		this.display_data.Funded_date = this.Payments.Funded_Date;
		this.display_data.Total_obligation_entire_term =
			this.Payments.Total_Obligation_Entire_Term_Final.toFixed(2);
		this.display_data.Total_cost_of_borrowing = (
			parseFloat(this.Payments.Actual_Cumulative_Interest.toFixed(2)) +
			parseFloat(this.Payments.Setup_Fee.toFixed(2))
		).toFixed(2);
		this.Payments.Start_Date = this.formatDate(this.Payments.Start_Date);
		this.display_data.Start_date = this.Payments.Start_Date;
		this.display_data.First_payment_amount =
			this.Payments.schedule[0].set_Amortization;
		//Last Payment amount should be changed here
		//this.display_data.Last_payment_amount = ((parseFloat(this.Payments.schedule[this.Payments.Term_of_Loan - 1].set_Amortization)) + this.Payments.LPP).toFixed(2)//Should the LPP be included over here
		this.display_data.Setup_fee = this.Payments.Setup_Fee.toFixed(2);
		this.display_data.CU_fee = this.Payments.CU_Fee.toFixed(2);
		this.display_data.Accumulative_interest =
			this.Payments.Actual_Cumulative_Interest.toFixed(2);
		this.display_data.LPP_total_interest =
			this.Payments.LPP_total_interest.toFixed(2);
		this.display_data.Term = (this.Payments.Duration * 12).toString();
		this.payment_Flag = true;
		this.scheduleArray = this.ProperSchedule.map((entries) =>
			Object.values(entries)
		);
		this.doc.text('Amortization Schedule', 160, 30);
		this.doc.setFontSize(12);
		this.doc.text(
			'Applicant Name: ' + this.loanInput.Application_Name.toString(),
			30,
			45
		);
		//this.doc.text("Loan Number: " + this.loanInput.Loan_Number.toString(), 30, 55)
		this.doc.text('Loan Date: ' + this.loanInput.Loan_Date, 30, 65);
		this.doc.text('Term Type: ' + this.loanInput.Term_Type, 30, 75);
		this.doc.text('Term/Term Due: NEED INFO', 30, 85);
		this.doc.text('Maturity Date: ' + this.loanInput.Last_Payment_Date, 30, 95);
		this.doc.text('Loan Amount: ' + this.loanInput.Loan_Amount, 30, 105);
		this.doc.text('Scheduled Payments: ' + this.Payments.Amortization, 30, 115);
		this.doc.text('Starting/Current Rate: NEED INFO', 30, 125);
		let col = [
			'Payment',
			'Payment Date',
			'Loan Amount',
			'Amortization Payment',
			'Balance',
		];
		autoTable(this.doc, {
			styles: {
				fontSize: 12,
			},
			theme: 'grid',
			startY: 150,
			head: [col],
			body: this.scheduleArray,
		});
		if (await this.validationAfterCalculation(this.loanInput.existing_flag)) {
			this.updateZOHOApplication();
			this.updateAdditionalDebtZOHOApplication();
			this.updateMonthlyPaymentsUnderwriting();
		} else {
			this.resetForm();
		}
		this.spinner = false;
	}
	updateTDSRMonthlyPayments() {}
	adjustLastPaymentDateandAmount() {
		let schedule_payment = this.display_data.Payment;
		console.log('Adjusting Last Payment');
		for (var i = 0; i < this.Payments.Term_of_Loan; i++) {
			if (parseFloat(this.Payments.schedule[i].set_LPP_Ending_Balance) < 0) {
				try {
					if (
						parseFloat(this.Payments.schedule[i - 1].set_LPP_Ending_Balance) <
						parseFloat(schedule_payment)
					) {
						console.log('WE ARE IN THE CONDITION ');
						this.display_data.Last_payment_amount = parseFloat(
							this.Payments.schedule[i - 1].set_LPP_Ending_Balance
						).toFixed(2);
						this.display_data.Maturity_date = this.formatMaturityDate(
							this.Payments.schedule[i].set_Payment_Date
						);
						this.Payments.Maturity_Date = this.display_data.Maturity_date;
						console.log(this.display_data.Last_payment_amount);
						console.log(this.display_data.Maturity_date);
						return;
					} else {
						console.log('WE ARE IN THE ELSE CONDITION');
						console.log(
							parseFloat(this.Payments.schedule[i - 1].set_LPP_Ending_Balance)
						);
						console.log(parseFloat(schedule_payment));
						this.display_data.Last_payment_amount = (
							parseFloat(this.Payments.schedule[i - 1].set_Amortization) +
							this.Payments.LPP
						).toFixed(2);
						this.display_data.Maturity_date = this.formatMaturityDate(
							this.Payments.schedule[i - 1].set_Payment_Date
						);
						this.Payments.Maturity_Date = this.display_data.Maturity_date;
						console.log(this.display_data.Last_payment_amount);
						console.log(this.display_data.Maturity_date);
						return;
					}
				} catch (err) {
					alert('error calculating Amo schedule');
					this.Payments.Maturity_Date = this.formatMaturityDate(
						this.Payments.schedule[this.Payments.Term_of_Loan - 1]
							.set_Payment_Date
					);
					this.display_data.Maturity_date = this.Payments.Maturity_Date;
					this.display_data.Last_payment_amount = (
						parseFloat(
							this.Payments.schedule[this.Payments.Term_of_Loan - 1]
								.set_Amortization
						) + this.Payments.LPP
					).toFixed(2); //Should the LPP be included over here
					return;
				}
			}
		}
		this.Payments.Maturity_Date = this.formatMaturityDate(
			this.Payments.schedule[this.Payments.Term_of_Loan - 1].set_Payment_Date
		);
		this.display_data.Maturity_date = this.Payments.Maturity_Date;
		this.display_data.Last_payment_amount = (
			parseFloat(
				this.Payments.schedule[this.Payments.Term_of_Loan - 1].set_Amortization
			) + this.Payments.LPP
		).toFixed(2); //Should the LPP be included over here
	}
	SavePDF() {
		this.doc.save(this.loanInput.Application_Name.concat(' AM Schedule.pdf'));
	}

	async checkApprovedAmountZOHO(): Promise<number> {
		return new Promise((resolve, reject) => {
			this.apiService
				.getZohoApplication(this.application.id)
				.subscribe((res) => {
					resolve(res['data'][0]['Amount']);
				});
		});
	}

	async updateZOHOApplication() {
		if (!this.zohoexists) {
			console.log(
				'Requesting application update via applicationChange callback'
			);
			const mainSettlementAmount = this.additionalDebt_settlment.filter(
				(item) => item.source === 'main'
			)[0]['Settlement_Amount'];
			const mainLegalFee = this.additionalDebt_settlment.filter(
				(item) => item.source === 'main'
			)[0]['Legal_Fee'];
			const totalLegalFees = this.additionalDebt_settlment
				.map((item) => item?.Legal_Fee)
				.reduce((prev, next) => parseFloat((prev + next).toFixed(2)));
			const mainAccountBalance = this.additionalDebt_settlment.filter(
				(item) => item.source === 'main'
			)[0]['dsLoanAmount'];

			this.Payments.mainSettlementAmount = mainSettlementAmount;
			this.Payments.mainLegalFee = mainLegalFee;
			this.Payments.customZOHOCount = await this.countCustomSettlement(
				this.application
			);
			this.Payments.totalLegalFees = totalLegalFees;
			this.Payments.mainAccountBalance = mainAccountBalance;
			this.Payments.waiveOffMode = this.loanInput.selectedWaiveOffMode ?? null;
			this.Payments.waiveOffRate = this.loanInput.waiveOffRate ?? null;
			console.log(
				this.loanInput.selectedWaiveOffMode,
				this.loanInput.waiveOffRate
			);
			this.apiService.updateZohoApplication(this.Payments).subscribe((res) => {
				if (!res)
					alert(
						'UNABLE TO CONNECT TO ZOHO - FUNDING DETAILS MUST BE MANUALLY UPDATED ON THE ZOHO APPLICATION'
					);

				this.applicationChange.emit(this.application);

				// Send signal to Agreement after submitting loan calculator and zoho updates
				if (!!this.data) {
					// // this._agreementDataService.emitResult('loan-calc', this.application.id);
					this._listenerService.emit('agreementUpdateCalc', this.data);
				}
				this.reloadLoanCalculator = false;
			});
		} else {
			console.log('Application was not updated');
		}
	}

	async updateAdditionalDebtZOHOApplication() {
		if (!this.zohoexists) {
			console.log('Zoho will be updated');
			this.apiService
				.updateAdditionalDebtZOHOApplication(this.additionalDebt_settlment)
				.subscribe((res) => {
					// console.log(res, "UDPATEZOHO++++++++++++++++")
					if (!res)
						alert(
							'UNABLE TO CONNECT TO ZOHO - FUNDING DETAILS MUST BE MANUALLY UPDATED ON THE ZOHO APPLICATION'
						);
				});
		} else {
			console.log('Zoho was not updated');
		}
	}
	async updateMonthlyPaymentsUnderwriting() {
		this.apiService
			.updateMonthlyPaymentsUnderwriting(
				this.Payments.application_id,
				this.Payments.Payment_Amount_Insurance_Monthly
			)
			.subscribe((res) => {
				console.log('Updating Monthly Payments');
				console.log(res);
			});
	}
	uploadGD() {
		if (
			confirm(
				'Are you sure you want to upload this Amortization schedule to Google Drive?'
			)
		) {
			this.loanInput.base64_PDF = JSON.stringify(
				this.doc.output('datauristring')
			);
			this.apiService.getGoogleDrive(this.loanInput).subscribe((res) => {});
		}
	}

	// Get the debt settlement variables
	getnewLoanAmount() {
		return new Promise((resolve, reject) => {
			this.apiService.getcalculatedNewLoanAmount().subscribe((res: any) => {
				resolve(res);
			});
		});
	}

	// Identify the variable values based on the naming
	getFees(creditorPortfolio: any, debtSettlementFees: any) {
		return Object.keys(debtSettlementFees).reduce(
			(result, key) => {
				creditorPortfolio = creditorPortfolio !== null ? creditorPortfolio : '';
				if (key.startsWith(creditorPortfolio?.toLowerCase())) {
					result[key] = debtSettlementFees[key];
				}
				return result;
			},
			{} as Record<string, number>
		);
	}

	// Add the calculated debt settlement amount
	getNewSettlementAmount(
		id: any,
		source: any,
		creditor: any,
		portfolio: any,
		originalRequested: any,
		customSettlement: any,
		customAgencyAmount: any
	) {
		return new Promise(async (resolve, reject) => {
			const dsCreditorFees = this.getFees(portfolio, this.debtSettlementFees);
			if (portfolio === 'Contingency') {
				this.dsRate = dsCreditorFees?.contingency_dsRate;
				this.dsFeeRate =
					this.application?.Province === 'BC'
						? this.debtSettlementFees?.BC_fee
						: dsCreditorFees?.contingency_dsFeeRate;
			} else if (portfolio === 'Purchase') {
				this.dsRate = dsCreditorFees?.purchase_dsRate;
				this.dsFeeRate =
					this.application?.Province === 'BC'
						? this.debtSettlementFees?.BC_fee
						: dsCreditorFees?.purchase_dsFeeRate;
			} else if (portfolio === 'Open') {
				this.dsRate = dsCreditorFees?.open_dsRate;
				this.dsFeeRate =
					this.application?.Province === 'BC'
						? this.debtSettlementFees?.BC_fee
						: dsCreditorFees?.open_dsFeeRate;
			}
			this.dsAmount =
				customSettlement === 'Yes'
					? 0
					: roundFigure(originalRequested * this.dsRate);
			this.dsLoanAmount =
				customSettlement === 'Yes'
					? customAgencyAmount
					: roundFigure(originalRequested - this.dsAmount);
			this.dsFee = roundFigure(this.dsLoanAmount * this.dsFeeRate);
			if (this.loanInput.selectedWaiveOffMode === 'Partial') {
				this.dsFee = roundFigure(
					this.dsFee * (1 - this.loanInput.waiveOffRate / 100)
				);
			}
			let hst_amount = roundFigure(
				this.dsFee * this.debtSettlementFees?.hst_rate
			);
			let fee_with_hst = roundFigure(this.dsFee + hst_amount);
			this.newLoanAmount = roundFigure(this.dsLoanAmount + fee_with_hst);
			this.additionalDebt_settlment.push({
				id: id,
				source: source,
				creditor: creditor,
				portfolio: portfolio,
				dsRate: this.dsRate,
				dsFeeRate: this.dsFeeRate,
				dsAmount: this.dsAmount,
				dsLoanAmount: this.dsLoanAmount,
				legal_fee_withoutHST: this.dsFee,
				Legal_Fee: fee_with_hst,
				hst_amount: hst_amount,
				account_balance: originalRequested,
				Settlement_Amount: this.newLoanAmount,
				Custom_Settlement: customSettlement,
			});
			resolve(true);
		});
	}

	// Merge parent and child debts
	populateNewCalculation(application: any) {
		return new Promise(async (resolve, reject) => {
			this.additionalDebt_settlment = [];
			this.additionalDebts =
				application?.Additional_Debt2 === 'Yes'
					? application?.Additional_Debt
					: [];
			const totalAdditionalDebt =
				this.additionalDebts.length > 0
					? this.additionalDebts
							.map((item) =>
								item?.Custom_Settlement === 'Yes'
									? item?.Custom_Agency_Amount
									: item?.Account_Balance
							)
							.reduce((prev, next) => prev + next)
					: 0;
			this.totalAccountBalance =
				application?.Custom_Settlement === 'Yes'
					? application?.Custom_Agency_Amount + totalAdditionalDebt
					: application?.Account_Bal + totalAdditionalDebt;
			this.totalAccountBalance = parseFloat(
				this.totalAccountBalance.toFixed(2)
			);
			this.loanInput.Creditor_Portfolio = application?.Creditor_Portfolio;
			await this.getNewSettlementAmount(
				application?.id,
				'main',
				application?.Creditt,
				application?.Creditor_Portfolio,
				application?.Account_Bal,
				application?.Custom_Settlement,
				application?.Custom_Agency_Amount
			);
			if (this.additionalDebts.length > 0) {
				for (let i = 0; i < this.additionalDebts.length; i++) {
					await this.getNewSettlementAmount(
						this.additionalDebts[i]?.id,
						'additional_debt',
						this.additionalDebts[i]?.misc,
						this.additionalDebts[i]?.Creditor_Portfolio,
						this.additionalDebts[i]?.Account_Balance,
						this.additionalDebts[i]?.Custom_Settlement,
						this.additionalDebts[i]?.Custom_Agency_Amount
					);
				}
			}
			const creditOwlFee =
				this.application?.Credit_Owl_Course === 'Yes' ||
				this.application?.Credit_Owl_Course === 'Accepted'
					? this.debtSettlementFees?.credit_owl_fee
					: 0;
			const creditOwlHST = roundFigure(
				creditOwlFee * this.debtSettlementFees?.hst_rate
			);
			// const totalHST = parseFloat((this.additionalDebt_settlment.map(item => item?.hst_amount).reduce((prev, next) => prev + next)).toFixed(2));
			this.grandTotalNewAmount = parseFloat(
				this.additionalDebt_settlment
					.map((item) => item?.Settlement_Amount)
					.reduce((prev, next) => prev + next)
					.toFixed(2)
			);
			this.grandTotalNewAmount = roundFigure(
				this.grandTotalNewAmount + creditOwlFee + creditOwlHST
			);
			this.loanAmountLoader = false;
			resolve(true);
		});
	}

	validateCreditorPortfolio(zohoData: any) {
		return new Promise((resolve, reject) => {
			const portifolioObject = ['contingency', 'purchase', 'open'];
			if (zohoData?.Additional_Debt2 === 'Yes') {
				if (objectExist(zohoData?.Additional_Debt)) {
					const parentPortfolioExist = portifolioObject.includes(
						convertLowerCase(zohoData?.Creditor_Portfolio)
					);
					const childPortfolioExist = zohoData?.Additional_Debt.every(
						(portfolio) => {
							return portfolio?.Custom_Settlement !== 'Yes'
								? portifolioObject.includes(
										convertLowerCase(portfolio?.Creditor_Portfolio)
									)
								: true;
						}
					);
					resolve(parentPortfolioExist && childPortfolioExist);
				} else {
					resolve(false);
				}
			} else {
				const parentPortfolioExist = portifolioObject.includes(
					convertLowerCase(zohoData?.Creditor_Portfolio)
				);
				resolve(parentPortfolioExist);
			}
		});
	}

	validateAccountBalance(zohoData: any) {
		return new Promise((resolve, reject) => {
			if (zohoData?.Additional_Debt2 === 'Yes') {
				if (objectExist(zohoData?.Additional_Debt)) {
					const parentAccountBalExist = zohoData?.Account_Bal !== null;
					const childAccountBalExist = zohoData?.Additional_Debt.every(
						(account) => {
							return account?.Custom_Settlement !== 'Yes'
								? account?.Account_Balance !== null
								: true;
						}
					);
					resolve(parentAccountBalExist && childAccountBalExist);
				} else {
					resolve(false);
				}
			} else {
				const parentAccountBalExist = zohoData?.Account_Bal !== null;
				resolve(parentAccountBalExist);
			}
		});
	}

	validateCustomSettlementAmount(zohoData: any) {
		return new Promise((resolve, reject) => {
			if (zohoData?.Additional_Debt2 === 'Yes') {
				if (objectExist(zohoData?.Additional_Debt)) {
					const parentCustomAgencyAmount =
						zohoData?.Custom_Settlement === 'Yes'
							? zohoData?.Custom_Agency_Amount !== null
								? true
								: false
							: true;
					const childCustomAgencyAmount = zohoData?.Additional_Debt.every(
						(custom) =>
							custom?.Custom_Settlement === 'Yes'
								? custom?.Custom_Agency_Amount !== null
									? true
									: false
								: true
					);
					resolve(parentCustomAgencyAmount && childCustomAgencyAmount);
				} else {
					resolve(false);
				}
			} else {
				const parentCustomAgencyAmount =
					zohoData?.Custom_Settlement === 'Yes'
						? zohoData?.Custom_Agency_Amount !== null
							? true
							: false
						: true;
				resolve(parentCustomAgencyAmount);
			}
		});
	}

	validateLoanAmountMatch(
		application: any,
		accountBalance: any
	): Promise<number> {
		return new Promise(async (resolve, reject) => {
			let mainResult = await this.loadValidateLoanAmount(
				application,
				accountBalance
			);
			const additionalDebtsV =
				application?.Additional_Debt2 === 'Yes'
					? application?.Additional_Debt
					: [];
			let subResult = 0;
			if (additionalDebtsV.length > 0) {
				for (let i = 0; i < additionalDebtsV.length; i++) {
					let result = await this.loadValidateLoanAmount(
						additionalDebtsV[i],
						additionalDebtsV[i]?.Account_Balance
					);
					subResult += result;
				}
			}
			const creditOwlFee =
				this.application?.Credit_Owl_Course === 'Yes' ||
				this.application?.Credit_Owl_Course === 'Accepted'
					? this.debtSettlementFees?.credit_owl_fee
					: 0;
			const creditOwlHST = roundFigure(
				creditOwlFee * this.debtSettlementFees?.hst_rate
			);
			resolve(
				roundFigure(mainResult + subResult + creditOwlFee + creditOwlHST)
			);
		});
	}

	loadValidateLoanAmount(
		application: any,
		accountBalance: any
	): Promise<number> {
		return new Promise((resolve, reject) => {
			const dsCreditorFees = this.getFees(
				application?.Creditor_Portfolio,
				this.debtSettlementFees
			);
			let dsRateV = 0;
			let dsFeeRateV =
				this.application?.Province === 'BC'
					? this.debtSettlementFees?.BC_fee
					: dsCreditorFees?.custom_dsFeeRate; // Default fee custom fee rate 28% BC: 32%
			if (application?.Creditor_Portfolio === 'Contingency') {
				dsRateV = dsCreditorFees?.contingency_dsRate;
				dsFeeRateV =
					this.application?.Province === 'BC'
						? this.debtSettlementFees?.BC_fee
						: dsCreditorFees?.contingency_dsFeeRate;
			} else if (application?.Creditor_Portfolio === 'Purchase') {
				dsRateV = dsCreditorFees?.purchase_dsRate;
				dsFeeRateV =
					this.application?.Province === 'BC'
						? this.debtSettlementFees?.BC_fee
						: dsCreditorFees?.purchase_dsFeeRate;
			} else if (application?.Creditor_Portfolio === 'Open') {
				dsRateV = dsCreditorFees?.open_dsRate;
				dsFeeRateV =
					this.application?.Province === 'BC'
						? this.debtSettlementFees?.BC_fee
						: dsCreditorFees?.open_dsFeeRate;
			}

			const dsAmountV =
				application?.Custom_Settlement === 'Yes'
					? 0
					: roundFigure(accountBalance * dsRateV);
			const dsLoanAmountV =
				application?.Custom_Settlement === 'Yes'
					? application?.Custom_Agency_Amount
					: roundFigure(accountBalance - dsAmountV);
			let dsFeeV = roundFigure(dsLoanAmountV * dsFeeRateV);
			if (this.loanInput.selectedWaiveOffMode === 'Partial') {
				dsFeeV = roundFigure(dsFeeV * (1 - this.loanInput.waiveOffRate / 100));
			}
			const hstFee = roundFigure(dsFeeV * this.debtSettlementFees?.hst_rate);
			// console.log(dsLoanAmountV, dsFeeV, hstFee, "dsLoanAmountV---------dsFeeV---------hstFee")
			const newLoanAmountV = roundFigure(dsLoanAmountV + dsFeeV + hstFee);
			// console.log(newLoanAmountV, "444445555555555")
			resolve(newLoanAmountV);
		});
	}

	countCustomSettlement(zohoData: any) {
		return new Promise((resolve, reject) => {
			let count = zohoData?.Custom_Settlement === 'Yes' ? 1 : 0;
			count +=
				zohoData?.Additional_Debt2 === 'Yes'
					? zohoData?.Additional_Debt.filter(
							(item) => item?.Custom_Settlement === 'Yes'
						).length
					: 0;
			resolve(count);
		});
	}

	updateLoanAmount(newLoanAmount: any) {
		this.sharedService.updateMessage(newLoanAmount);
	}

	checkLoanCalculatorEntry() {
		return new Promise((resolve, reject) => {
			this.apiService
				.getCalculatorInstance(this.loanInput.application_id)
				.subscribe(async (res) => {
					this.performDurationUpdate = res ? false : true;
					resolve(true);
				});
		});
	}

	async requestLegalFeeWaiveOff(waiveOffMode: string) {
		this.verifiedResult = await this.verifyWaiveOff(
			this.application.id,
			this.currentUser?.employeeID
		);
		if (this.verifiedResult?.activeCount > 0) {
			this.confirmAction(
				`Full exception Count: ${
					this.verifiedResult?.exceptionCount?.full + 1
				} \nThis file has ${
					this.verifiedResult?.activeCount
				} active request. \nDo you still want to request ${waiveOffMode} legal fee waive-off?`
			);
		} else {
			this.confirmAction(
				`Full exception Count: ${
					this.verifiedResult?.exceptionCount?.full + 1
				} \nDo you want to request ${waiveOffMode} legal fee waive-off?`
			);
		}
	}

	verifyWaiveOff(applicationId: string, employeeID: number): Promise<any> {
		return new Promise((resolve, reject) => {
			this.apiService
				.verifyWaiveOff(applicationId, employeeID)
				.subscribe((res: any) => {
					resolve(res);
				});
		});
	}

	confirmAction(confirmMessage: any) {
		const requestData = {
			applicationId: this.application.id,
			applicationName: this.application?.Deal_Name,
			agentId: this.currentUser?.employeeID,
			agentName: this.currentUser?.full_name,
			agentEmail: this.currentUser?.email,
			province: this.application?.Province,
			exceptionCount: this.verifiedResult?.exceptionCount?.full + 1,
		};
		if (confirm(confirmMessage) == true) {
			const dialogRef = this.dialog.open(LegalFeeExceptionModalComponent, {
				height: '260px',
				width: '500px',
				autoFocus: true,
				disableClose: true,
				data: requestData,
			});

			dialogRef.afterClosed().subscribe((result) => {
				if (result) {
					// Send signal to Agreement after submitting loan calculator and zoho updates
					if (!!this.data) {
						this._agreementDataService.emitResult(
							'waiveOff-request',
							this.application.id
						);
					}
					this.refreshUnlockCalculator();
				}
			});
		}
	}

	oldCalculatorLink() {
		const url = this.router.serializeUrl(
			this.router.createUrlTree([
				`/applications/summary/${this.application.id}/oldCalculator`,
			])
		);
		window.open(url, '_self');
	}
	refreshUnlockCalculator() {
		const unlockTimer = setInterval(async () => {
			this.verifiedResult = await this.verifyWaiveOff(
				this.application.id,
				this.currentUser?.employeeID
			);
			console.log('Refresh unlock Calculator!');
			if (
				this.verifiedResult?.isApproved?.mode === 'Partial' &&
				this.verifiedResult?.isApproved?.approved
			) {
				this.loanInput.selectedWaiveOffMode = 'Partial';
				clearInterval(unlockTimer);
				// this.resetForm();
			}
			if (
				this.verifiedResult?.isApproved?.mode === 'Full' &&
				this.verifiedResult?.isApproved?.approved
			) {
				this.loanInput.selectedWaiveOffMode = 'Full';
				clearInterval(unlockTimer);
				this.resetForm();
			}
		}, 30000);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.application?.currentValue && this.reloadLoanCalculator) {
			this.application = changes.application?.currentValue;
			if (this.application) {
				this.initializeComponentData();
			}
		}
		if (changes.currentUser?.currentValue) {
			this.currentUser = changes.currentUser?.currentValue;
		}
	}

	private async initializeComponentData(): Promise<void> {
		if (this.application) {
			// Initialize missing variables using application object as summary data
			this.hasCreditorPortfolio = await this.validateCreditorPortfolio(
				this.application
			);
			this.hasAccountBalance = await this.validateAccountBalance(
				this.application
			);
			this.hasCustomSettlement = await this.validateCustomSettlementAmount(
				this.application
			);
			this.selectedProvince =
				typeof this.application.Province === 'undefined' ||
				this.application.Province === null
					? 'Province: Not selected on ZOHO'
					: 'Province: '.concat(this.application?.Province);

			this.loan_type = [
				{
					value: 'Standard',
					viewValue:
						this.application?.Province === 'BC'
							? 'Standard (31%)'
							: 'Standard (34.99%)',
				},
				{ value: 'Old Standard', viewValue: 'Old Standard (49.99%)' },
				{ value: 'Click and Loan', viewValue: 'Click and Loan (25.99%)' },
				{ value: 'Custom', viewValue: 'Variable Interest Rate' },
			];
			await this.populateCalc();

			if (this.application && this.currentUser) {
				this.verifiedResult = await this.verifyWaiveOff(
					this.application.id,
					this.currentUser?.employeeID
				);
				if (this.verifiedResult?.activeCount > 0) {
					if (this.verifiedResult?.isApproved?.approved) {
						this.loanInput.selectedWaiveOffMode =
							this.verifiedResult?.isApproved?.mode;
					}
					this.refreshUnlockCalculator();
				}
			}
		}
	}

	onFundedDetailsClicked() {
		this.dialog.open(FundedDetailsModalComponent, {
			width: '900px',
			data: { application: this.application },
		});
	}

	partialWaiveOff() {
		const appInfo = {
			applicationId: this.application.id,
			applicationName: this.application?.Deal_Name,
			agentId: this.currentUser?.employeeID,
			agentName: this.currentUser?.full_name,
			agentEmail: this.currentUser?.email,
			province: this.application?.Province,
			exceptionCount: this.verifiedResult?.exceptionCount + 1,
		};
		const dialogRef = this.dialog.open(PartialWaiveoffModalComponent, {
			height: '550px',
			width: '500px',
			autoFocus: true,
			disableClose: true,
			data: {
				loanInput: { ...this.loanInput },
				loanDebts: this.additionalDebt_settlment,
				appInfo: appInfo,
			},
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				// this.refreshUnlockCalculator();
				this.resetForm();
			}
		});
	}

	/**
	 * For loan script to load after all required info on loan calculator is complete
	 * @param value
	 */
	setLoading(value: boolean): void {
		this.loadingLoanScript.next(value);
	}

	/**
	 * Loan script modal
	 */
	sahaLppScript() {
		this.loading$
			.pipe(
				filter((loading) => !loading),
				take(1)
			)
			.subscribe((test) => {
				const dialogRef = this.dialog.open(LoanCalculatorScriptComponent, {
					maxHeight: '85vh',
					width: '40vw',
					position: {
						top: '100px',
						left: '120px',
					},
					autoFocus: true,
					disableClose: true,
					panelClass: 'hide-dialog-scrollbar',
					data: {
						isSaha: true,
						loanInput: {
							...this.loanInput,
						},
						loanDebts: this.additionalDebt_settlment,
						appName: this.application?.Deal_Name,
						checkPayments: this.Payments,
						payments: {
							payment: this.display_data.Payment,
							lpp: this.display_data.LPP,
							isEnhanced: this.display_data.isEnhanced,
						},
					},
				});
				dialogRef.afterClosed().subscribe((result) => {
					if (result === 'confirmed') {
						const data = {
							applicationId: this.application.id,
							confirmedBy: this.currentUser?.employeeID,
						};
						this.apiService
							.confirmedLoanApprovalScript(data)
							.subscribe((res) => {
								console.log(res);
							});
					}
				});
			});
	}

	preventDecimal(event: KeyboardEvent) {
		if (event.key === '.' || event.key === ',') {
			event.preventDefault();
		}
	}

	ngAfterViewInit(): void {
		// Show the header bar shadow only once the summary content has scrolled
		const scrollContainer = this._elementRef.nativeElement.closest(
			'.scrollable-content'
		);
		if (!scrollContainer) {
			return;
		}
		fromEvent(scrollContainer, 'scroll', { passive: true })
			.pipe(
				map(() => scrollContainer.scrollTop > 0),
				distinctUntilChanged(),
				takeUntil(this._onDestroy)
			)
			.subscribe((isScrolled) => (this.isScrolled = isScrolled));
	}

	ngOnDestroy() {
		if (this.verifiedResult) {
			clearInterval(this.verifiedResult);
		}
		this._onDestroy.next();
		this._onDestroy.complete();
	}
}

const convertLowerCase = (portfolio: any) => {
	return portfolio?.toLowerCase() ?? '';
};

const objectExist = (zohoData: any) => {
	return zohoData?.length > 0;
};

const roundFigure = (amount: any) => {
	return parseFloat(amount.toFixed(2));
};
